/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */



class Responses{
    constructor(params) {
        this.response = {id:new Date().getTime()};
        this.response.type = "success";
        this.setResponseParameters(params);   
        if (params.data){
            this.setMessageData(params.data);
        } 
    }

    

        
    
    
    setResponseParameters(params){
            for (var prop in params){
                if (params.hasOwnProperty(prop)){
                    var method = "setResponse" + prop.charAt(0).toUpperCase() + prop.slice(1);
                    if (this[method]){
                        this[method](params[prop]);
                    }
                    
                }
            }

        }

   
    setResponseStatus(val){
        this.response.status = val;
        this.response.codeIndex = (val == 200) ? false : val;
        this.response.hasError = (val == 200) ? false : true;
        this.response.type = (val == 200) ? "success" : "error";
    }

    setMessageData(o){
        this.response.notifications = o;

        this.response.statusText = "";
        
            Object.keys(o).map((or) => {
                this.response.statusText += or + ": " + o[or];
            })
        
        if (o.pageContent){
            this.setResponseContent(o.pageContent);
        }
    }

    setResponseContent(o){
        this.response.pageContent = o;
    }

    setResponseStatusText(val){
        this.response.statusText = this.response.statusText ? this.response.statusText : val;
    }

    setResponseCode(code){
        this.response.code = code;
    }

    setResponseCodeIndex(idx){
        this.response.codeIndex = idx;
    }

    setResponseId(responseId){
        this.response.id = responseId;
    }

    }
    
  
export default Responses;
          